import React from "react";
import Close from "@material-ui/icons/Close";
import nsw from "../assets/img/flr-nsw-glam.png";
import ps4 from "../assets/img/flr-ps4-glam.jpeg";
import track from "./Track";

export const Modal = ({ show, setShow }) => {
  React.useEffect(() => {
    // window.scrollTo({ top: 0, behavior: "smooth" });
  }, [show]);

  return (
    <div
      className="modal flex"
      style={{
        position: "absolute",
        left: "0",
        height: "initial",
        width: "100%",
        minHeight: "110vh",
        display: show ? "flex" : "none",
        zIndex: 5,
        overflowY: "hidden",
      }}
      onClick={() => setShow(false)}
    >
      <div
        className="btn viewer"
        style={{
          margin: "16px",
          fontSize: "1rem",
          position: "fixed",
          top: 0,
          right: 0,
        }}
        onClick={() => setShow(false)}
      >
        <Close style={{ color: "white", fontSize: "2rem" }} />
      </div>
      <div
        className={`store flex row wrap`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={`flex`}>
          <img
            src={ps4}
            alt=""
            style={{ margin: "15px" }}
            className={`glam ${
              show ? "animate__animated animate__fadeIn animate__slow" : ""
            }`}
          />
          <div className="flex">
            <h3 style={{ margin: 0, fontSize: "2em" }} className="font1">
              Exemplary Edition
            </h3>
            <p
              className="font3"
              style={{
                backgroundColor: "white",
                color: "black",
                maxWidth: "450px",
                width: "70%",
                fontSize: "1em",
              }}
            >
              Preorder this limited edition collection for Fallen Legion
              Revenants, exclusive to the NISAmerica Online Store!
            </p>
          </div>
          <div className="flex row wrap" style={{ width: "90%" }}>
            <a
              href={null}
              target="_blank"
              style={{ textDecoration: "none" }}
              onClick={() => track("Preorder - NISA Online Store")}
            >
              <div
                className={`sub ${
                  show
                    ? "animate__animated animate__fadeInUp animate__slow"
                    : ""
                }`}
                style={{ fontSize: "1.3rem", width: "initial" }}
              >
                SOLD OUT!
              </div>
            </a>
          </div>
        </div>
        <div className={`flex`}>
          <img
            src={nsw}
            alt=""
            style={{ margin: "15px" }}
            className={`glam ${
              show ? "animate__animated animate__fadeIn animate__slow" : ""
            }`}
          />
          <div className="flex">
            <h3 style={{ margin: 0, fontSize: "2em" }} className="font1">
              Vanguard Edition
            </h3>
            <p
              className="font3"
              style={{
                backgroundColor: "white",
                color: "black",
                maxWidth: "450px",
                width: "70%",
                fontSize: "1em",
              }}
            >
              Preorder the day one edition for Fallen Legion Revenants at your
              favorite retailer!
            </p>
          </div>
          <div className="flex row">
            <a
              href="https://www.gamestop.com/video-games/switch/games/products/fallen-legion-revenants-vanguard-edition/11103408.html"
              target="_blank"
              style={{ textDecoration: "none" }}
              onClick={() => track("Preorder - GameStop")}
            >
              <div
                className={`sub ${
                  show
                    ? "animate__animated animate__fadeInUp animate__slow"
                    : ""
                }`}
                style={{ fontSize: "1.3em", width: "initial" }}
              >
                GameStop
              </div>
            </a>
            <a
              href="https://www.amazon.com/dp/B08BQVY8XV/"
              target="_blank"
              style={{ textDecoration: "none" }}
              onClick={() => track("Preorder - Amazon")}
            >
              <div
                className={`sub ${
                  show
                    ? "animate__animated animate__fadeInUp animate__slow"
                    : ""
                }`}
                style={{ fontSize: "1.3em", width: "initial" }}
              >
                Amazon
              </div>
            </a>
            <a
              href="https://www.bestbuy.com/site/fallen-legion-revenants-vanguard-edition-nintendo-switch/6422842.p?skuId=6422842"
              target="_blank"
              style={{ textDecoration: "none" }}
              onClick={() => track("Preorder - Best Buy")}
            >
              <div
                className={`sub ${
                  show
                    ? "animate__animated animate__fadeInUp animate__slow"
                    : ""
                }`}
                style={{ fontSize: "1.3em", width: "initial" }}
              >
                Best Buy
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
